import { render, staticRenderFns } from "./TarifFields.vue?vue&type=template&id=91089a3e&scoped=true"
import script from "./TarifFields.vue?vue&type=script&lang=ts"
export * from "./TarifFields.vue?vue&type=script&lang=ts"
import style0 from "./TarifFields.vue?vue&type=style&index=0&id=91089a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91089a3e",
  null
  
)

export default component.exports